export default __webpack_public_path__ + "static/media/check-icon.4f3ef84c.svg";